import axios from 'axios';

export type RetakePayment = {
  id: number;
  adminId: number | null;
  bankAccountId: number | null;
  transactionId: string;
  ngayGD: string | null;
  soTien: string;
  noiDung: string | null;
  tenNguoiCK: string | null;
  cccdMatched: string | null;
  maKySHMatched: string | null;
  hoTenMatched: string | null;
  trangThai: 'matched' | 'unmatched';
  bankAccount?: { bankName: string; accountNumber: string } | null;
};

type ListResult = {
  total: number;
  page: number;
  limit: number;
  rows: RetakePayment[];
};

type Filters = {
  tuNgay?: string;
  denNgay?: string;
  trangThai?: string;
  page?: number;
  limit?: number;
};

export const listRetakePaymentsApi = async (filters: Filters): Promise<ListResult> => {
  const params = new URLSearchParams();
  if (filters.tuNgay)    params.set('tuNgay', filters.tuNgay);
  if (filters.denNgay)   params.set('denNgay', filters.denNgay);
  if (filters.trangThai) params.set('trangThai', filters.trangThai);
  if (filters.page)      params.set('page', String(filters.page));
  if (filters.limit)     params.set('limit', String(filters.limit));
  const res = await axios.get(`/api/admin/retake-payments?${params}`);
  if (res.data.EC !== 0) throw new Error(res.data.EM);
  return res.data.DT;
};

export const exportRetakePaymentsCsvUrl = (filters: Omit<Filters, 'page' | 'limit'>): string => {
  const params = new URLSearchParams();
  if (filters.tuNgay)    params.set('tuNgay', filters.tuNgay);
  if (filters.denNgay)   params.set('denNgay', filters.denNgay);
  if (filters.trangThai) params.set('trangThai', filters.trangThai);
  return `/api/admin/retake-payments/export?${params}`;
};
